<template>
	<form class="reset-password-form" @submit.prevent="submit">
		<div class="fieldset">
			<FieldInput
				name="password"
				type="password"
				label="New password"
				v-model="fields.password"
				:errors="errors.password"
			/>
		</div>
		<div class="fieldset">
			<FieldInput
				name="passwordConfirmation"
				type="password"
				label="Confirm new password"
				v-model="fields.passwordConfirmation"
				:errors="errors.passwordConfirmation"
			/>
		</div>
		<input type="hidden" name="code" v-model="fields.code" />
		<div class="fieldset">
			<SubmitButton v-bind="submitButton" label="Reset password" />
		</div>
	</form>
</template>

<script>
import FieldInput from '@/components/shared/FieldInput'
import SubmitButton from '@/components/shared/SubmitButton'
import form from '@/mixins/form'

export default {
	name: 'ResetPasswordForm',
	created() {
		this.form.populate({ code: this.$route.query.code })
	},
	mixins: [form.resetPassword],
	components: {
		FieldInput,
		SubmitButton
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.reset-password-form {
	width: 100%;
	max-width: 20rem;
	.fieldset {
		margin-bottom: 2rem;
	}
	input[type='submit'] {
		@include button;
	}
}
</style>
